import { gql } from '@gql-generated/gql'
import type { ProductDetailInfos_ProductFragment } from '@gql-generated/graphql'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { productArticlesAtom, selectedReferenceAtom } from '../services/product.store'

gql(/* GraphQL */ `
  fragment ProductArticleDetails_Article on Product {
    mainTechnicalSpecs {
      ...ProductTechnicalSpecs_TechnicalSpecs
    }
    technicalSpecs {
      ...ProductTechnicalSpecs_TechnicalSpecs
    }
    norms {
      ...ProductNorms_Norm
    }
    documents {
      ...ProductDocuments_Documents
    }
    ...ProductLabels_Product
    ...ProductRichDescription_Product
  }
`)

type UseProductInfosProps = {
  product: ProductDetailInfos_ProductFragment
}

export function useProductInfos({ product }: UseProductInfosProps) {
  const productArticles = useAtomValue(productArticlesAtom)
  const selectedReference = useAtomValue(selectedReferenceAtom)

  const selectedArticle = useMemo(() => {
    if (!selectedReference || !productArticles.length) return null

    return productArticles.find((article) => article.reference === selectedReference) ?? null
  }, [productArticles, selectedReference])

  const activeProduct = useMemo(() => {
    return {
      ...product,
      ...selectedArticle,
    }
  }, [product, selectedArticle])

  return {
    activeProduct,
  }
}
